import { create } from "zustand";

import { RequestType } from "@/types/user";

const DEFAULT_REQUEST_FORM: RequestType = {
  email: "",
  contactNumber: "",
  personName: "",
  companyName: "",
  text: "",
  source: "",
  sourceEtc: "",
  entryPoint: "request_page",
  title: "",
  minYears: null,
  maxYears: null,
};

interface RequestFormStoreType {
  form: RequestType;
  setForm: (name: string, value: RequestType[keyof RequestType]) => void;
  resetForm: () => void;
}

const useRequestFormStore = create<RequestFormStoreType>()((set) => ({
  form: DEFAULT_REQUEST_FORM,
  setForm: (name, value) => set((prevState) => ({ form: { ...prevState.form, [name]: value } })),
  resetForm: () => set(() => ({ form: DEFAULT_REQUEST_FORM })),
}));

export default useRequestFormStore;
